import { viewerApi } from '../api/viewer';
import common from '../lib/common';
import { useLoginStore } from '../lib/store';

type VisangViewerElType =
    | 'kv-service-view'
    | 'kv-assessment-container'
    | 'kv-homework-container'
    | 'kv-result-container'
    | 'kv-ailearning-container'
    | 'v-skin';

const userState = useLoginStore.getState();

const kstVersion = () => {
    const d = new Date(Date.now() + 9 * 60 * 60 * 1000); // KST = UTC+9
    const p = (n: number) => ('0' + n).slice(-2);
    return (
        d.getUTCFullYear() +
        p(d.getUTCMonth() + 1) +
        p(d.getUTCDate()) +
        '-' +
        p(d.getUTCHours()) +
        p(d.getUTCMinutes())
    );
};

export default {
    sendToElement: (el: VisangViewerElType, data: any, type: string, key?: any, index?: number) => {
        const container = document.getElementsByTagName(el);
        if (!index) {
            index = 0;
        }
        const getDetail = () => {
            switch (typeof data) {
                case 'boolean':
                case 'number':
                case 'string':
                    return data;

                default: {
                    if (Array.isArray(data)) {
                        return JSON.stringify([...data]);
                    }
                    return JSON.stringify({ ...data });
                }
            }
        };
        if (container && container[index]) {
            const msgtype = type + (key != undefined ? key : '');
            const ev = new CustomEvent(msgtype, { detail: getDetail() });
            common.log('[NAVI] 발신 >> [' + el + ']', type, ev);

            container[index].dispatchEvent(ev);
        }
    },

    linkToPageEventListenser: async (e: any) => {
        // const navigate = useNavigate();
        // const EvalStore = store.classMaterials.evaluation;
        // const HwkStore = store.classMaterials.homework;

        common.log('[NAVI] 링크 페이지 이벤트 수신', e);
        const { detail: _detail } = e;
        let detail = null;
        try {
            detail = JSON.parse(_detail);
        } catch (e) {
            detail = _detail;
        }

        const param: EvlTaskInfo.Req = {
            textbkId: userState.textbookId,
            userId: userState.loginInfo?.memberId,
            claId: '',
            setsId: detail.set_id,
            matrialType: detail.category === 'homework' ? '1' : '2',
        };

        const result = await viewerApi.getTchEvlTaskInfo(param);
        return result;
        // if (result) {
        //     if (detail.category === 'question-paper') {
        //         await EvalStore.getInfo(result.id);
        //         navigate(AppRoutes.ClassMaterialsEvalGuide.path);
        //     } else {
        //         await HwkStore.getInfo(result.id);
        //         navigate(AppRoutes.ClassMaterialsHwkGuide.path);
        //     }
        // }
    },

    initViewerScript: (onload?: () => void) => {
        // 이 애플리케이션 자체가 module script로 실행되므로 모던 브라우저임을 뷰어 게이트에 알린다.
        // 값이 없으면 legacy 번들이 Lodash보다 먼저 실행되어 `_ is not defined`가 발생할 수 있다.
        window.__aidt_is_modern_browser = true;

        const appJsUrl =
            import.meta.env.VITE_TTUK_VIEWER + '/js/aidt-viewer-gate.js' + `?v=${kstVersion()}`;
        const appScript = Array.from(document.scripts).find((script) => {
            try {
                return new URL(script.src).pathname.endsWith('/js/aidt-viewer-gate.js');
            } catch {
                return false;
            }
        });

        // 분 단위 캐시 버스터가 바뀌어도 게이트를 중복으로 추가하지 않는다.
        if (!appScript) {
            const appScript = document.createElement('script');
            appScript.type = 'module';
            appScript.src = appJsUrl;
            appScript.onload = () => {
                if (onload) onload();
            };
            document.head.append(appScript);
        }
    },
    initEditorScript: (onload?: () => void) => {
        // 저작 튤 스크립트 로딩
        // const editorJsUrl =
        //     import.meta.env.VITE_TTUK_EDITOR + '/js/editor.js' + `?v=${kstVersion()}`;
        // const isEditorScript = document.querySelector('script[src="' + editorJsUrl + '"]');
        // if (!isEditorScript) {
        //     const editorScript = document.createElement('script');
        //     editorScript.type = 'module';
        //     editorScript.src = editorJsUrl;
        //     editorScript.defer = false;
        //     editorScript.onload = () => {
        //         if (onload) onload();
        //     };
        //     document.head.append(editorScript);
        // }
    },
};
